import { createApp } from 'vue';
import App from './App.vue';
import pinia from './stores';
import router from './router';
import i18n from './plugins/i18n';
import { installApi } from './plugins/api';
import { installAnalytics } from './plugins/analytics';

import '@fontsource-variable/inter';
import './style.css';

// The appointment-manager variant (admin area and its test booking page) uses the warm
// theme from style.css; magazin, network and predikto keep their own look.
if (!['predikto', 'magazin', 'network'].includes(import.meta.env.VITE_APP_VARIANT ?? '')) {
  document.documentElement.classList.add('theme-warm');
}

const app = createApp(App);

app.use(pinia);
installApi(app, pinia);
app.use(router);
installAnalytics(app, router);
app.use(i18n);

app.mount('#app');
